module.exports = __webpack_public_path__ + "img/31_32.ff07d064.png";